import { render, staticRenderFns } from "./TeacherApplicableManagement.vue?vue&type=template&id=64a00ded&scoped=true"
import script from "./TeacherApplicableManagement.vue?vue&type=script&lang=js"
export * from "./TeacherApplicableManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a00ded",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64a00ded')) {
      api.createRecord('64a00ded', component.options)
    } else {
      api.reload('64a00ded', component.options)
    }
    module.hot.accept("./TeacherApplicableManagement.vue?vue&type=template&id=64a00ded&scoped=true", function () {
      api.rerender('64a00ded', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/survey_form/component/child_component/TeacherApplicableManagement.vue"
export default component.exports